const FCM_REDUX_CONSTANT = {
  CLEAR_ALL_NOTIFICATION: 'CLEAR_ALL_NOTIFICATION',
  ADD_NEW_NOTIFICATION: 'ADD_NEW_NOTIFICATION',
  ADD_ALL_NOTIFICATION: 'ADD_ALL_NOTIFICATION',
};
export default FCM_REDUX_CONSTANT;
